module.exports = __webpack_public_path__ + "img/thumbnail_FennecFox_m_normal.86ace16c.png";